const UserFacingError = require('../libraries/DigiTickets/Errors/UserFacingError');
const { toFloat, toInt, toString } = require('@/functions/transform');

/**
 * VariableDiscount contains the amount and narrative of a variable offer for a specific order line.
 *
 * @constructor
 *
 * @param {number} [offerID]
 */
const VariableDiscount = function (offerID) {
    if (offerID !== undefined) {
        offerID = parseInt(offerID, 10);

        if (Number.isNaN(Number(offerID)) || offerID < 1) {
            throw new Error('offerID must be positive integer');
        }
    }

    /**
     * @type {number}
     */
    this.offerID = offerID;

    /**
     * @type {number}
     */
    this.amount = 0.00;

    /**
     * @type {string}
     */
    this.narrative = '';
};

VariableDiscount.prototype = {

    /**
     * @param {number} amount
     */
    setAmount(amount) {
        amount = parseFloat(amount);

        if (Number.isNaN(Number(amount))) {
            throw new UserFacingError('Amount must be a number', 'VARIABLE_DISCOUNT.AMOUNT_MUST_BE_NUMBER');
        }

        if (!amount) {
            throw new UserFacingError('Amount must not be zero', 'VARIABLE_DISCOUNT.AMOUNT_REQUIRED');
        }

        this.amount = amount;
    },

    /**
     * @param {string} narrative
     */
    setNarrative(narrative) {
        if (!narrative || narrative.trim() === '') {
            throw new UserFacingError('Discount reason is required', 'VARIABLE_DISCOUNT.NARRATIVE_REQUIRED');
        }

        this.narrative = narrative;
    },

    /**
     * Return the amount formatted for displaying on the discount's button.
     * (Sign is flipped)
     *
     * @return {number}
     */
    getDisplayAmount() {
        return -this.amount;
    },

    getHydrationMap() {
        return {
            offerID: toInt,
            amount: toFloat,
            narrative: toString,
        };
    },
};

module.exports = VariableDiscount;
